import React, {Component, Fragment} from "react"
import styled from "styled-components"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"

import ScheduledGroupCelebrationsQuery, {
  getScheduledGroupCelebrationList,
  QueryVariables,
  scheduledGroupCelebrationsQuery
} from "@irati/recognition/apollo/query/ScheduledGroupCelebrations"
import Loader from "@irati/utils/services/apollo/Loading/Loader"
import LoadMore from "@irati-web/admin/src/components/Settings/CompanyBenefitsList/LoadMore"
import {GroupCelebration} from "@irati/types"
import {TransitionFeed} from "../../../components/Feed"
import ScheduledGroupCelebration from "../../../components/Polls/ClosedPoll/ScheduledGroupCelebration"
import Empty from "./Empty"

const Feed = styled(TransitionFeed)`
  margin-bottom: ${({theme}) => theme.spacing.four};
`
interface State {
  variables: QueryVariables
}
class ScheduledGroupCelebrations extends Component<{}, State> {
  state = {
    variables: scheduledGroupCelebrationsQuery.variables
  }

  handleNewPage = (isVisible: boolean, apollo: ApolloState<any, QueryVariables>) => {
    if (isVisible) {
      const {results, cursor} = getScheduledGroupCelebrationList(apollo)
      const {variables} = this.state
      const resultsLength = results?.length || 0
      if (resultsLength && !!cursor && cursor !== "null") {
        return apollo.fetchMore({...variables, cursor})
      }
    }
  }

  render() {
    return (
      <ScheduledGroupCelebrationsQuery variables={this.state.variables}>
        {(apollo) => {
          const scheduledGroupCelebrationList = getScheduledGroupCelebrationList(apollo)
          return (
            <Fragment>
              {scheduledGroupCelebrationList.results && (
                <Feed
                  arr={scheduledGroupCelebrationList.results}
                  component={({item}: {item: GroupCelebration}) => <ScheduledGroupCelebration key={item.uuid} groupCelebration={item} />}
                />
              )}
              <LoadMore onVisible={(isVisible: boolean) => this.handleNewPage(isVisible, apollo)} />
              {apollo.loading && <Loader />}
              {!apollo.loading && !scheduledGroupCelebrationList.results.length && <Empty />}
            </Fragment>
          )
        }}
      </ScheduledGroupCelebrationsQuery>
    )
  }
}

export default ScheduledGroupCelebrations
